import { defineStore } from 'pinia'

export const useBookStore = defineStore({
  id: 'book',
  state: (): {
    /** Bookのロック状態 */
    lockState: Set<string>
  } => ({
    lockState: new Set(),
  }),
  getters: {},
  actions: {
    unlock(bookHash: string) {
      this.lockState.add(bookHash)
    },
    lock(bookHash: string) {
      this.lockState.delete(bookHash)
    },
    isUnlocked(bookHash: string) {
      return this.lockState.has(bookHash)
    },
    clear() {
      this.lockState.clear()
    },
  },
})
